import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const USE_OF_INCOME_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.distributesIncome,
    label: "Use Of Income",
    tooltip: CatalogReferenceDataSlugs.distributes_income,
    type: ColumnTypes.string,
    width: 160,
    cellValue: (item) => {
        if (item.isAsset) {
            const distributes_income = item.distributes_income;

            if (distributes_income === null) {
                return null;
            }

            return distributes_income ? "Distributes" : "Accumulates";
        }

        return null;
    },
};
